export default __webpack_public_path__ + "static/speed-gauge-01-tr-057b2f2363c62e30aa1bc1eb18edd7e3.png";